import CreateGlue from "./glue";

let whatToExpose = CreateGlue;
let shouldSetToWindow = true;

if (typeof window !== "undefined") {
    // if glue42gd (running in GD3) and autoInjected
    const glue42gd = (window as any).glue42gd;
    if (glue42gd && glue42gd.autoInjected) {
        whatToExpose = (window as any).Glue;
        // no need to set to window, it's already there
        shouldSetToWindow = false;
    }

    if (shouldSetToWindow) {
        (window as any).Glue = whatToExpose;
    }

    // remove GlueCore from the window object (injected by Glue-core)
    delete (window as any).GlueCore;
}
// add default library for ES6 modules
(whatToExpose as any).default = whatToExpose;

export default whatToExpose;
